import { render, staticRenderFns } from "./halogenkohlenwasserstoffe.vue?vue&type=template&id=dd0b69c8&"
import script from "./halogenkohlenwasserstoffe.vue?vue&type=script&lang=js&"
export * from "./halogenkohlenwasserstoffe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports